import type { BoxProps } from '@withjoy/joykit';
import { Box } from '@withjoy/joykit';
import React from 'react';
import { SearchInputBar } from '../CatalogSearchBar/components/SearchInputBar';
import { useSearchBar } from '../CatalogSearchBar/hooks/useSearchBar';
import { EditGiftDialog } from '@apps/registry/admin/components/EditGift';
import { useShippingAddressAndCurrencyDialogsContext } from '../../../ShippingAddressAndCurrencyDialogsProvider';
import { useCatalogContext } from '../../state/Catalog';
import { useTranslation } from '@shared/core';
import { TrendingSearchList } from '../CatalogSearchBar/components/TrendingSearchList';
import { useShopStorefrontContext } from '../ShopStorefrontProvider';

interface CatalogSearchBarInputProps
  extends Readonly<
    {
      placeholder?: string;
    } & Omit<BoxProps, '__css'>
  > {
  onFocus?: () => void;
  onBlur?: () => void;
  isFocused?: boolean;
}

export const CatalogSearchBarInput = (props: CatalogSearchBarInputProps) => {
  const { eventId } = useCatalogContext();
  const {
    clearSearchText,
    handleOnChange,
    handleOnFocus,
    handleOnBlur,
    handleOnKeyDown,
    handleOnSubmit,
    searchText,
    handleOnPasteSearch,
    onCloseEditGiftDialog,
    isOpenEditGiftDialog,
    handleOnSelectOptionSearchQuery,
  } = useSearchBar({
    onFocus: props.onFocus,
    onBlur: props.onBlur,
  });
  const { openCurrencyDialog } = useShippingAddressAndCurrencyDialogsContext();
  const storeFront = useShopStorefrontContext();
  const { t2 } = useTranslation('sharedComponents');
  const { placeholder } = t2('searchBar');
  return (
    <Box
      width="100%"
      position="relative"
    >
      <SearchInputBar
        {...props}
        clearSearchText={clearSearchText}
        handleOnFocus={handleOnFocus}
        handleOnBlur={handleOnBlur}
        handleOnChange={handleOnChange}
        handleOnKeyDown={handleOnKeyDown}
        handleOnSubmit={handleOnSubmit}
        searchText={searchText}
        handleOnPasteSearch={handleOnPasteSearch}
        placeholder={eventId ? placeholder : undefined}
      />
      {props.isFocused && !storeFront.isBabyStorefront && (
        <TrendingSearchList
          searchValue={searchText}
          onSelectOption={handleOnSelectOptionSearchQuery}
        />
      )}

      {eventId && (
        <EditGiftDialog
          prefilledUrl={searchText}
          eventId={eventId}
          isOpen={isOpenEditGiftDialog}
          product={null}
          onClose={onCloseEditGiftDialog}
          currency={'$'}
          showCurrencyDialog={openCurrencyDialog}
        />
      )}
    </Box>
  );
};
